import type { CSSProperties } from "react";
import { deviceDetector, ospThemes } from "@ospweb/sdk-ui";

import type { EdgenModalCreateAbleProps } from "@/src/components/EdgenModal";

export const ADD_ACCOUNT_MODAL_PC_WIDTH_PX = 420;

const desktopContentSize = {
  maxHeight: "min(520px, 90vh)",
  height: "auto",
} as const;

export const addAccountModalShellProps = (): Pick<
  EdgenModalCreateAbleProps,
  | "centered"
  | "className"
  | "containerClassName"
  | "contentStyle"
  | "containerStyle"
  | "styles"
  | "titleStyle"
  | "showClose"
  | "closable"
  | "destroyOnClose"
  | "swipeToClose"
  | "dragThreshold"
  | "maskClosable"
> => {
  const isMobile = deviceDetector.isMobile();

  const sharedContentStyle: CSSProperties = {
    backgroundColor: ospThemes.colors.background_solid_neutral_secondary,
    padding: 0,
    overflow: "hidden",
    width: "100%",
    maxWidth: isMobile ? "100vw" : `${ADD_ACCOUNT_MODAL_PC_WIDTH_PX}px`,
    display: "flex",
    flexDirection: "column",
    borderRadius: isMobile ? "16px 16px 0 0" : "12px",
    ...(isMobile ? { maxHeight: "min(90dvh, 520px)" } : desktopContentSize),
  };

  return {
    centered: !isMobile,
    showClose: false,
    closable: false,
    destroyOnClose: true,
    swipeToClose: isMobile,
    dragThreshold: isMobile ? 100 : undefined,
    maskClosable: true,
    className: isMobile ? undefined : "!max-w-[420px]",
    containerClassName: isMobile
      ? "!w-screen !max-w-[100vw]"
      : "!rounded-[12px] !overflow-hidden !w-full !max-w-[420px]",
    contentStyle: sharedContentStyle,
    containerStyle: {
      padding: 0,
      overflow: "hidden",
      width: "100%",
      maxHeight: "100%",
    },
    styles: {
      content: sharedContentStyle,
      body: {
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        padding: 0,
        overflow: "hidden",
      },
      wrapper: {
        zIndex: 10000,
      },
      mask: {
        zIndex: 10000,
      },
    },
    titleStyle: {
      minHeight: 0,
    },
  };
};
